import { useEffect, useState } from 'react';
import { fetchAPI } from '../../../utils/utils';

// People outside the colla who answered on the web, as the server keeps them
// (backend/form-guests.js): the name they typed and the member the junta linked
// the answer to. The junta's lists name them from here, with «(web)».

const typedName = (mote) => {
  let name = String(mote || '');
  try { name = decodeURIComponent(name); } catch { /* as it is */ }
  name = name.trim();
  return name.toUpperCase() === 'VISITANT' ? '' : name;
};

const memberName = (person) => person?.mote || [person?.nom, person?.cognom].filter(Boolean).join(' ');

// How an answer that isn't a member's is called in the lists
export const guestLabel = (userId, response, formGuests = {}, castellersInfo = {}) => {
  const guest = formGuests?.[userId];
  const linked = guest?.casteller_id != null ? castellersInfo?.[guest.casteller_id] : null;
  if (linked && memberName(linked)) return `${memberName(linked)} (web)`;
  const name = guest?.name || typedName(response?.mote);
  return name ? `${name} (web)` : 'Visitant (web)';
};

// The name a web answer was given, to look for who it can be
export const guestTypedName = (userId, response, formGuests = {}) => formGuests?.[userId]?.name || typedName(response?.mote);

// { guest_<hex>: { name, casteller_id } } of an event, again when it changes
export const useFormGuests = (selectedEvent, socket) => {
  const [formGuests, setFormGuests] = useState({});
  useEffect(() => {
    if (!selectedEvent) return undefined;
    let current = true;
    const load = () => fetchAPI(`/form_guests/${selectedEvent}`, (rows) => {
      if (!current || !Array.isArray(rows)) return;
      setFormGuests(Object.fromEntries(rows.map((row) => [row.id, row])));
    }, false, () => {});
    load();
    const onChange = (data) => {
      if (data === undefined || String(data?.evId ?? data) === String(selectedEvent)) load();
    };
    socket?.on?.('.form_guests_changed', onChange);
    socket?.on?.('.new_response', onChange);
    return () => {
      current = false;
      socket?.off?.('.form_guests_changed', onChange);
      socket?.off?.('.new_response', onChange);
    };
  }, [selectedEvent, socket]);
  return formGuests;
};
